import React from "react"

import { FieldArray, useField } from "formik"

import { XMarkIcon } from "@heroicons/react/24/solid"

import { Button } from "~tailwindui/Basics"
import { Error, FileInput } from "~tailwindui/Form"

import classNames from "src/classNames"

const ReceiptsInput = () => {
  const [field, meta] = useField("receipts")
  const [expenseType] = useField("expenseType")

  if (expenseType.value === "intro_session") return null
  return (
    <FieldArray name="receipts">
      {arrayHelpers => (
        <>
          {field.value.map((_receipt, index) => (
            <div key={index} className="flex items-center justify-between">
              <FileInput
                name={`receipts[${index}]`}
                hideErrors
                label="Receipt"
              />

              <button type="button" onClick={() => arrayHelpers.remove(index)}>
                <XMarkIcon className="h-8 w-8 cursor-pointer text-gray-500 hover:text-red-500" />
              </button>
            </div>
          ))}

          <Button
            type="button"
            outline
            className={classNames(!meta.error && "mb-5")}
            onClick={() => arrayHelpers.push({})}
          >
            Add Receipt
          </Button>

          <Error name="receipts" />
        </>
      )}
    </FieldArray>
  )
}

export default ReceiptsInput
